module.exports = __webpack_public_path__ + "static/media/teaser3-radeberger-x2.016393da.jpg";